import CVProfile from "./CVProfile";

export default CVProfile;

/*
import React from "react";
import { Helmet } from "react-helmet-async";
import { PROFILE, REALISATIONS } from "../config/routes";
import "./styles/Cv.css";

const CVFlorianWeb = () => {
  const siteUrl = "https://dreameragency.fr";

  return (
    <>
      <Helmet>
        <title>Florian Da Cunha - Développeur full-stack React Node TypeScript</title>
        <meta
          name="description"
          content="Profil développeur full-stack de Florian Da Cunha : React, Node.js, TypeScript, applications web, SaaS, mobile, API et produits digitaux complets."
        />
        <link rel="canonical" href={`${siteUrl}${PROFILE}`} />
        <meta property="og:title" content="Florian Da Cunha - Développeur full-stack" />
        <meta
          property="og:description"
          content="Profil développeur full-stack React / Node.js / TypeScript, orienté applications web, SaaS, mobile, API et solutions métiers."
        />
        <meta property="og:type" content="profile" />
        <meta property="og:url" content={`${siteUrl}${PROFILE}`} />
      </Helmet>

      <div className="cv-container">
      <header className="cv-header">
        <h1>Florian DA CUNHA</h1>
        <p>Toulouse, France</p>
        <p>Email : <a href="mailto:floriandc.dev@gmail.com">floriandc.dev@gmail.com</a></p>
        <p>Téléphone : 06 18 15 62 74</p>
        <p>
          <a href="https://www.linkedin.com/in/florian-da-cunha-a242a21a0/" target="_blank" rel="noopener noreferrer">LinkedIn</a> | 
          <a href="https://github.com/floriandcdev" target="_blank" rel="noopener noreferrer">GitHub</a> | 
          <a href={`${siteUrl}${REALISATIONS}`} target="_blank" rel="noopener noreferrer">Portfolio</a>
        </p>
      </header>

      <section className="cv-section">
        <h2>Développeur Web & Mobile Polyvalent</h2>
        <p>
          Ingénieur informatique passionné, je conçois des applications robustes et évolutives, aussi bien sur le web que sur mobile. J’aime transformer les idées en interfaces concrètes, fonctionnelles et élégantes, et je suis capable d’intervenir aussi bien sur le front-end que sur le back-end, voire sur des couches plus basses si nécessaire.
        </p>
      </section>

      <section className="cv-section">
        <h2>Compétences techniques</h2>
        <ul>
          <li><strong>Langages :</strong> React, Node.js, MySQL, NoSQL, C++, C#, Python, Windev, HTML/CSS, JavaScript, Linux, Bash</li>
          <li><strong>Outils :</strong> GitHub, Postman, Figma, outils spécifiques selon les projets</li>
        </ul>
      </section>

      <section className="cv-section">
        <h2>Expériences</h2>
        <div className="cv-experience">
          <h3>CEICOM – Développeur ERP (PL/I)</h3>
          <p>Septembre 2020 – Septembre 2023 (alternance)</p>
          <ul>
            <li>Développement et maintenance d’un ERP métier (Distel) en langage PL/I</li>
            <li>Participation à toutes les étapes du cycle en V</li>
            <li>Interaction quotidienne avec les équipes fonctionnelles</li>
          </ul>
        </div>
        <div className="cv-experience">
          <h3>Auto-entrepreneur – Développeur Web & Mobile</h3>
          <p>Octobre 2023 – Mai 2025</p>
          <ul>
            <li>Création d'applications pour clients dans divers secteurs (restauration, événementiel, éducation)</li>
            <li>Stack utilisée : React, Node.js, Supabase, Flutter, Unity</li>
            <li>Livraison de projets complets : design, développement, déploiement</li>
          </ul>
        </div>
      </section>

      <section className="cv-section">
        <h2>Formation</h2>
        <p>EPSI Toulouse – Diplôme d’ingénieur en informatique (Bac+5) – Septembre 2020 à Septembre 2023 (alternance)</p>
      </section>

      <section className="cv-section">
        <h2>Projets personnels / freelance</h2>
        <p>
          Pour découvrir les projets réalisés dans le cadre freelance ou personnel, consultez mon portfolio : 
          <a href={`${siteUrl}${REALISATIONS}`} target="_blank" rel="noopener noreferrer">dreameragency.fr/realisations</a>
        </p>
      </section>

      <section className="cv-section">
        <h2>Langues</h2>
        <ul>
          <li>Français : Natif</li>
          <li>Anglais : B2 (niveau de conversation courant, pratiqué quotidiennement à l’oral)</li>
        </ul>
      </section>
      </div>
    </>
  );
};

export default CVFlorianWeb;
*/
